<template>
    <BSidebar v-if="tax" id="add-new-tax-sidebar" :visible="status" bg-variant="white" sidebar-class="sidebar-lg" shadow backdrop no-header right @change="(val) => $emit('update:status', val)">
        <template #default="{ hide }">
            <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                <h5 class="mb-0"> Añadir un impuesto</h5>
                <FeatherIcon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
            </div>
            <ValidationObserver  ref="form">
                <BForm class="p-2" >
                    <TextInputValidated vsName="Name" :vsModel.sync="tax.name" vsLabel="name" vsRequired vsRules="required" />
                    <NumberInputValidated vsName="Value (%)" :vsModel.sync="tax.value" vsLabel="value" vsStep="0.01" vsRequired vsRules="required" />
                    <NumberInputValidated vsName="Sucharge equivalence (%)" :vsModel.sync="tax.equivalence" vsStep="0.01" vsLabel="equivalence" vsRequired vsRules="required"/>
                    <div class="d-flex mt-2">
                        <BButton v-if="!taxToEdit.id" variant="primary" class="mr-2" @click="onSubmit"> {{ $t('Add') }} </BButton>
                        <BButton v-else variant="primary" class="mr-2"  @click="updateTax(tax.id)"> {{ $t('Edit') }} </BButton>

                        <BButton type="button" variant="outline-secondary" @click="hide"> {{ $t('Cancel') }} </BButton>
                    </div>
                </BForm>
            </ValidationObserver>
        </template>
    </BSidebar>
</template>

<script>
import { BButton, BForm, BSidebar } from 'bootstrap-vue';
import { ValidationObserver } from 'vee-validate';
import { FeatherIcon } from 'vue-feather-icons';
import { ref, toRefs, inject, watch } from '@vue/composition-api';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import store from '@/store';
import axios from '@axios';
import popups from '@/hooks/popups';


export default {
    components: { BSidebar, FeatherIcon, ValidationObserver, BForm, TextInputValidated, NumberInputValidated, BButton },
    props: ['status'],
    emit: ['update:status'],
    setup(props, { emit }){
        const { errorToast, successToast } = popups()
        const form = ref(null)
        const blankTax = {
            id:'',
            name: '',
            value: '',
            equivalence: ''
        }
        const taxToEdit = inject('taxToEdit')
        const tax = ref(taxToEdit)

        const resetForm = function(){
            tax = JSON.parse(JSON.stringify(blankTax))
        }
        
        const onSubmit = function(){

            this.$refs.form.validate().then(success => {
                if (success) {
                    store.dispatch('taxes/addTax', tax.value).then(() => {
                    emit('refetch-data')
                    emit('update:status', false)
                })
                }

            })

        }

        const updateTax = function (id) {
            this.$refs.form.validate().then(success => {
                if (success) {
                    axios.put(`/taxes/${id}`, tax.value).then((response) => {
                        if (response.data.success) {
                            successToast("Impuesto actualizado correctamente")
                            emit('refetch-data')
                            emit('update:status', false)
                        } else {
                            errorToast("Ha habido un error")
                        }

                    }).catch((error) => {
                    })
                }
            })   
        }



        return {
            resetForm,
            onSubmit,
            form,
            tax,
            taxToEdit,
            updateTax
        }
    }
}
</script>

<style>
    form > div {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
</style>